var __TEMP__ = require('./_root.js');var root = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = coreJsData;
